import { render, staticRenderFns } from "./CandidateBenefits.vue?vue&type=template&id=604162a5&scoped=true&"
var script = {}
import style0 from "./CandidateBenefits.vue?vue&type=style&index=0&id=604162a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604162a5",
  null
  
)

component.options.__file = "CandidateBenefits.vue"
export default component.exports